module.exports = __webpack_public_path__ + "img/formulaEle.d7b317b8.svg";